import { useState, useEffect } from "react";
import './Login.css';
import App from "../../App";
import Config from "../../Config";

export default function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [loggedin, setLoggedin] = useState(false);

    // 🔹 Prüfen, ob User schon eingeloggt ist
    useEffect(() => {
        fetch(Config.LoginURL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({}), // leere POST für Session-Check
        })
            .then(res => res.json())
            .then(data => {
                if (data.loggedin) setLoggedin(true);
            });
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();

        // Passwort in SHA-256 hashen
        const hashPassword = async (password) => {
            const encoder = new TextEncoder();
            const data = encoder.encode(password);
            const hashBuffer = await crypto.subtle.digest('SHA-256', data);
            // ArrayBuffer in hex string umwandeln
            return Array.from(new Uint8Array(hashBuffer))
                .map(b => b.toString(16).padStart(2, '0'))
                .join('');
        };

        const hashedPassword = await hashPassword(password);

        const res = await fetch(Config.LoginURL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ username, password: hashedPassword }),
        });

        const data = await res.json();
        setMessage(data.message);
        if (data.success) setLoggedin(true);
    };


    const handleLogout = async () => {
        const res = await fetch(Config.LoginURL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ action: "logout" }),
        });
        const data = await res.json();
        setMessage(data.message);
        setLoggedin(false);
    };

    // 🔹 Conditional Render
    if (loggedin) {
        return (
            <div>
                <App />
                {/* {message && <p>{message}</p>} */}
            </div>
        );
    }

    return (
        <form className="LoginForm" onSubmit={handleLogin}>

            <h2>Kalendarium - Login</h2>

            <input
                type="text"
                placeholder="Benutzername"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
            />

            <input
                type="password"
                placeholder="Passwort"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />

            <button type="submit">Login</button>
            {message && <p>{message}</p>}
        </form>
    );
}
